<template>
  <lu-vbox>

    <lu-hbox v-if='inData && inData.length >= 1' :class="isLargeMode ? 'small-riskexposure-container' : 'riskexposure-container'" lu-flex-wrap style='margin-bottom: 10px;'>
      <!-- <lu-hbox lu-flex-wrap > -->
        <lu-hbox v-for='item in inData' :key='item.currency' style='margin-right: 7px; ' >
          <lu-hbox class='panels'>
            <el-tooltip placement="bottom" :effect='styleTooltip'>
              <div slot="content">
                <lu-vbox v-for='rec in item.instrumentList' :key='rec.currency'>
                  <lu-hbox class='tooltip'>
                    <lu-item lu-flex class='itemTitle'>{{ rec.instrumentName | itemTitle }} :</lu-item>
                    <lu-item class='itemValue' :class='rec.profitAndLoss >= 0  ? "positive" : "negative"'>{{ rec.profitAndLoss | formatAmount }}</lu-item>
                  </lu-hbox>
                </lu-vbox>
              </div>
                <lu-hbox lu-vcenter lu-hcenter lu-flex lu-click class='panel-item' @dblclick='getDetail(item.currency)' v-if='isLargeMode'>
                  <lu-item class='itemTitle'>{{ item.currency | itemTitle }} </lu-item>
                  <lu-item lu-flex class='itemValue' :class='item.profitAndLoss >= 0  ? "positive" : "negative"'>{{ item.profitAndLoss | formatAmount }}</lu-item>
                </lu-hbox>

                <lu-vbox lu-vcenter lu-hcenter lu-flex lu-click class='panel-item' @dblclick='getDetail(item.currency)' v-else>
                  <lu-item class='itemTitle'>{{ item.currency | itemTitle }} </lu-item>
                  <lu-item class='itemValue' :class='item.profitAndLoss >= 0  ? "positive" : "negative"'>{{ item.profitAndLoss | formatAmount }}</lu-item>
                </lu-vbox>

            </el-tooltip>
          </lu-hbox>
        </lu-hbox>
      <!-- </lu-hbox> -->

    </lu-hbox>
    <lu-item v-else style='padding-top: 50px;justify-content:center;'>No data</lu-item>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import { mapGetters, mapState } from 'vuex'
import monitoringMixin from './mixins'

export default {
  name: 'Exposure',
  components: { LuHbox, LuVbox, LuItem },
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  data: function () {
    return {
      mode: '1'
    }
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatPercent: function (value) {
      return value + ' %'
    },
    itemTitle: function (value) {
      return !value ? 'Total' : value
    }
  },
  computed: {
    ...mapGetters([ 'theme' ]),
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    isLargeMode: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp && tmp.options ? tmp.options.mode === '2' : true
    },
    inData: function () {
      let res = {}
      if (this.data) {
        res = this.data.filter(item => item.currency !== '')
      }
      return res
    },
    excelColumns () {
      let columns = []
      for (let i = 0; i < 26; i++) {
        columns.push(String.fromCharCode(0x41 + i))
      }
      for (let i = 0; i < 26; i++) {
        for (let j = 0; j < 26; j++) {
          columns.push(String.fromCharCode(0x41 + i) + String.fromCharCode(0x41 + j))
        }
      }
      return columns
    }
  },
  methods: {
    onClose: function () {
      this.$emit('close', 'ccyExposure')
    },
    getDetail: function (cuy) {
      let params = [
        {'paramName': 'origin', 'paramValue': 'ProfitAndLoss'},
        {'paramName': 'Currency', 'paramValue': cuy}
      ]
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: 'currency', value: cuy, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: 'currency', value: cuy, params: params, show: true})
    },
    handleDownload (dataList, sheetOnly,activeName,filePrefix) {
      return import('@/vendor/Export2Excel').then(excel => {

        const tHeader = ['Currency', 'Total', 'Instrument', 'P&L']
        const filterVal = ['currency','totalProfitAndLoss', 'instrumentName', 'profitAndLoss']
        let merges = []


        const columns = this.excelColumns
        let row = 2

        let data = []
        dataList.forEach(ccy => {
          if (ccy) {
            if (ccy.instrumentList && ccy.instrumentList.length){
              ccy.instrumentList.forEach(ins => {
                if (ins) {
                  data.push({
                    currency : ccy.currency === '' ? 'Total' : ccy.currency,
                    totalProfitAndLoss : ccy.profitAndLoss,
                    instrumentName: ins.instrumentName,
                    profitAndLoss: ins.profitAndLoss
                  })
                }
              })
              if (ccy.instrumentList.length>1) {
                merges.push(columns[0] + row.toString() + ':' + columns[0] + (row + ccy.instrumentList.length -1).toString())
                merges.push(columns[1] + row.toString() + ':' + columns[1] + (row + ccy.instrumentList.length-1).toString())
              }
              row+=ccy.instrumentList.length
            } else {
                data.push({
                  currency : ccy.currency === '' ? 'Total' : ccy.currency,
                  totalProfitAndLoss : ccy.profitAndLoss,
                  instrumentName: '',
                  profitAndLoss: ''
                })
                row++
            }
          }
        })
        const list = data
        const formatdata = this.formatJson(filterVal, list)
        if (sheetOnly) {
          return {
            data: formatdata,
            header: tHeader,
            merges: merges,
            sheetName: filePrefix
          }
        }

        let filename = filePrefix + '_' +  timestamp()
        excel.export_json_to_excel_lusis({
          header: tHeader,
          data: formatdata,
          filename: filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
          merges: merges,
          sheetName: filePrefix
        })

      })
    }
  }
}
</script>

<style lang='scss' scoped>

.riskexposure-container {
  padding: 10px 0;
  position: relative;
  // background-color: blue;

  .panel-item {
    min-width: 130px;
    padding: 10px;
    margin: 0 0px 10px 10px;
    border-radius: 5px;
    border: 2px solid transparent;
  }

  .panel-item .itemTitle {
    font-size: 1.5rem;
    text-align: center;
  }

  .panel-item .itemValue {
    font-size: 1.5rem;
    text-align: center;
    padding-top: 10px;
  }

  .totalExp {
    float: right;
    color: red;
    position: absolute;
    left: 95%;
    top: 4%;
    margin-left: -100px; /*half the width*/
  }
}


.small-riskexposure-container {
  padding: 0px 0;
  position: relative;

  .panel-item {
    min-width: 150px;
    padding: 5px 10px;
    margin: 3px;
  }

  .panel-item .itemTitle {
    font-size: 1.2rem;
    text-align: left;
  }

  .panel-item .itemValue {
    font-size: 1.2rem;
    text-align: right;
    justify-content:  flex-end;
  }

  .totalExp {
    float: right;
    color: red;
    position: absolute;
    left: 95%;
    top: 5%;
    margin-left: -100px; /*half the width*/
  }
}

.tooltip {
      padding: 3px;
  }

  .tooltip .itemTitle{
    padding: 3px;
  }

  .tooltip  .itemValue{
    padding: 3px;
    text-align: right;
    justify-content:  flex-end;
  }

</style>